import H2 from "@/atoms/text/H2";
import H3 from "@/atoms/text/H3";
import Para from "@/atoms/text/Para";
import Image from "@/atoms/Image";

const PromoSection = ({
  title,
  content,
  cardTitle,
  cardContent,
  image,
  source,
}) => {
  return (
    <section className="bc-white pv-15-d pv-8">
      <div className="container">
        <div className="fx-d fx--sb fx--cv mb-10-d mb-7">
          {title && (
            <H2
              desktopSize="lg"
              mobileSize="sm"
              className="mb-reset-d mb-5 w-50-d bold"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {content?.map((text, idx) => {
            const contentKey = `content_${idx}`;
            return (
              <Para
                key={contentKey}
                className={`w-50-d ${idx === content.length - 1 ? "" : "mb-5"}`}
                desktopSize="lg"
                mobileSize="lg"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            );
          })}
        </div>
        <div className="ps-r">
          <div className="card-bg-img fx fx--c z-index-1">
            {cardTitle && (
              <H3
                desktopSize="sm"
                mobileSize="xs"
                className="w-50-d mb-3 bold"
                color="white"
                dangerouslySetInnerHTML={{ __html: cardTitle }}
              />
            )}
            {cardContent?.map((text, idx) => {
              const contentKey = `content_${idx}`;
              return (
                <Para
                  key={contentKey}
                  color="white"
                  className={`w-50-d pr-2 ${
                    idx === cardContent.length - 1 ? "" : "mb-5"
                  }`}
                  desktopSize="lg"
                  mobileSize="lg"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              );
            })}
          </div>
          <Image
            fileName={image.fileName}
            desktopWidth={image.desktopWidth}
            desktopHeight={image.desktopHeight}
            mobileWidth={image.mobileWidth}
            alt={image.altName}
            fileFormat="png"
          />
        </div>
        <Para
          desktopSize="lg"
          mobileSize="lg"
          color="black"
          dangerouslySetInnerHTML={{ __html: source }}
          className="mt-6-d mt-7"
        />
      </div>
      <style jsx>{`
        .card-bg-img {
          position: absolute;
          padding: 60px;
        }
        @media (max-width: 1024px) {
          .card-bg-img {
            padding: 32px 20px;
          }
        }
      `}</style>
    </section>
  );
};

export default PromoSection;
